// refer https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
// DnB module is in async chunk, dynamic import bootstrap ensures that shared modules are loaded correctly when DnB is run as standalone app
import('./bootstrap');
